
import checkSuspendWebsite from '~/mixins/pages/login/checkSuspendWebsite'
export default {
    name: 'RegisterPage',
    mixins: [checkSuspendWebsite],
}
